export default "__VITE_ASSET__b897c8f6__"